import { useEffect } from 'react';
import { useAppDispatch } from 'flow/hooks/useRedux';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import useProfiles from 'flow/hooks/useProfiles';
import { fetchMainNumbers, fetchProfiles } from 'flow/actions/profile-actions';
import { routes } from 'flow/types/routes';
import CallerIdSettingsEdit from '../settings/CalleridSettingsEdit';
import Page from './Page';
import Loading from 'flow/components/ui-components/Loading';
import { ExtensionKey, ProfileKey } from 'flow/types/EntityKeys';
import { hasLandlineCallerId } from 'flow/utils/profile-utils';
import { generatePath } from 'flow/utils/router-utils';

const CallerIdTypes = () => {
    const dispatch = useAppDispatch();
    const history = useHistory();
    const { extensionKey, numberType, profileKey } = useParams<{
        extensionKey: ExtensionKey;
        numberType: 'fixed' | 'msisdn';
        profileKey?: ProfileKey;
    }>();

    const { profiles } = useProfiles(extensionKey);

    useEffect(() => {
        if (!numberType || !extensionKey) {
            return;
        }
        dispatch(fetchProfiles(extensionKey));
        dispatch(fetchMainNumbers(extensionKey));
    }, [extensionKey, numberType]);

    if (!numberType || !extensionKey) {
        return <Loading />;
    }

    const handleBack = () => {
        if (profileKey) {
            history.push(
                generatePath(routes['settings.callerid.profile.numberType'], {
                    extensionKey,
                    numberType,
                }),
            );
        } else {
            history.push(
                generatePath(routes['settings.callerid'], { extensionKey }),
            );
        }
    };

    if (!profiles.first()) {
        return <Loading />;
    }

    if (numberType === 'fixed' && !hasLandlineCallerId(profiles.first())) {
        return (
            <Redirect
                to={generatePath(routes['settings.callerid'], { extensionKey })}
            />
        );
    }

    return (
        <Page header="settings.callerid" onClickBack={handleBack}>
            <CallerIdSettingsEdit />
        </Page>
    );
};

export default CallerIdTypes;
